angular.module( 'angus.directives' ).directive( 'salesReport', [
    'actionViewTemplates',
    function( actionViewTemplates ) {
        return {
            scope: {
                model      : "=actionModel",
                settings   : "=salesReportWidgetSettings",
                widgetCode : "="
            },
            templateUrl: actionViewTemplates.salesReportContainer
        };
    }
] );